export default {
  namespaced: true,
  state: {
    showFaqSidebar: false,
    showLimitsSidebar: false,
    showLogoutDialog: false,
    showSwitchDialog: false,
    showAppSidebar: false,
    showFavoriteModal: false,
    showAutomobileModal: false,
    showAutopaymentModal: false,
    showReceiptModal: false,
    showSuggestions: {
      isShow: false,
      productId: null,
    },
  },
  getters: {
    getAutoPaymentModalStatus(state) {
      return state.showFavoriteModal;
    },
    getFavoriteModalStatus(state) {
      return state.showFavoriteModal;
    },
    getAutomobileModal(state) {
      return state.showAutomobileModal;
    },
    getshowFaqSidebar(state) {
      return state.showFaqSidebar;
    },
    getShowLimitsSidebar(state) {
      return state.showLimitsSidebar;
    },
    getShowLogoutDialog(state) {
      return state.showLogoutDialog;
    },
    getShowSwitchDialog(state) {
      return state.showSwitchDialog;
    },
    getShowAppSidebar(state) {
      return state.showAppSidebar;
    },
    getReceiptModalStatus(state) {
      return state.showReceiptModal;
    },
    getShowSuggestions(state) {
      return state.showSuggestions;
    },
  },
  mutations: {
    setAutoPaymentModalStatus(state, status) {
      state.showFavoriteModal = status;
    },
    setFavoriteModalStatus(state, status) {
      state.showFavoriteModal = status;
    },
    setAutomobileModalStatus(state, status) {
      state.showAutomobileModal = status;
    },
    setshowFaqSidebar(state, status) {
      state.showFaqSidebar = status;
    },
    setLimitsSidebar(state, payload) {
      state.showLimitsSidebar = payload;
    },
    setLogoutDialogStatus(state, status) {
      state.showLogoutDialog = status;
    },
    setAppSidebarStatus(state, status) {
      state.showAppSidebar = status;
    },
    setSwitchDialogStatus(state, status) {
      state.showSwitchDialog = status;
    },
    setReceiptModalStatus(state, status) {
      state.showReceiptModal = status;
    },
    setShowSuggestions(state, status) {
      state.showSuggestions = status;
    },
  },
  actions: {
    setAutoPaymentStatus({ commit }, status) {
      commit('setAutoPaymentModalStatus', status);
    },
    setFavoriteStatus({ commit }, status) {
      commit('setFavoriteModalStatus', status);
    },
    setAutomobileStatus({ commit }, status) {
      commit('setAutomobileModalStatus', status);
    },
    setFaqStatus({ commit }, status) {
      commit('setshowFaqSidebar', status);
    },
    setLimitsStatus({ commit }, status) {
      commit('setLimitsSidebar', status);
    },
    setLogoutStatus({ commit }, status) {
      commit('setLogoutDialogStatus', status);
    },
    setSidebarStatus({ commit }, status) {
      commit('setAppSidebarStatus', status);
    },
    setSwitchStatus({ commit }, status) {
      commit('setSwitchDialogStatus', status);
    },
    setReceiptModalStatus({ commit }, status) {
      commit('setReceiptModalStatus', status);
    },
    setShowSuggestions({ commit }, status) {
      commit('setShowSuggestions', status);
    },
  },
};
